import { convertTimestampToDate } from "../utils/convertTimestampToDate";
import api from "../api/axios";
import { encrypt } from "../utils/crypto";

export const fetchCompanySubscription = async (companyId, subscription_id = null) => {
  try {
    // handle if no subscriptions found, treat same as expired
    const response = await api.get(`subscriptions/company`, {
      params: { company_id: companyId , subscription_id : subscription_id },
    });
    return response.data.data;
  } catch (error) {
    console.error("Error fetching subscription:", error);
    throw error;
  }
};

export const checkSubscriptionExpiry = (subscriptions) => {
  if (!subscriptions || subscriptions.length === 0) return false;

  // Step 1: Sort subscriptions by end_date (latest first)
  const sorted = [...subscriptions].sort(
    (a, b) => new Date(b.end_date) - new Date(a.end_date)
  );

  // Step 2: Pick the latest subscription
  const latest = sorted[0];

  // Step 3: Compare with current date
  const currentDate = new Date();
  const expiryDate = new Date(latest.end_date);

  const isExists =  expiryDate < currentDate;
  
  if(isExists){
    localStorage.setItem("expired_subscription",  encrypt(latest?.subscription_id))
  }
  return isExists;
};


export const isSubscriptionExpirySoon = (subscriptions) => {
  if (!subscriptions || subscriptions.length === 0) return false;

  // Step 1: Sort subscriptions by end_date (latest first)
  const sorted = [...subscriptions].sort(
    (a, b) => new Date(b.end_date) - new Date(a.end_date)
  );

  // Step 2: Pick the latest subscription
  const latest = sorted[0];

  // Step 3: Compare with current date
  const currentDate = new Date();
  const expiryDate = new Date(latest.end_date);

  // Calculate difference in days
  const diffInMs = expiryDate - currentDate;
  const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

  // Step 4: Return true if 1–5 days left
  const isExists = diffInDays > 0 && diffInDays <= 5;

  if (isExists) {
    localStorage.setItem(
      "expired_subscription",
      encrypt(latest?.subscription_id)
    );
  }

  return isExists;
};





